# Našeptávač adres z registru (CZ, SK, PL, AT, SI) na poli ulice s data-address-autocomplete="URL".
# data-zip / data-town = selektory polí k doplnění, data-country = selektory výběru země (bere se první vyplněný)
$(document).on 'turbolinks:load', ->
  $('input[data-address-autocomplete]').each ->
    input = $(this)
    country = ->
      for selector in input.data('country').split(',')
        value = $(selector).val()
        return value if value
      ''

    input.autocomplete
      minLength: 3
      delay: 250
      source: (request, response) ->
        return response([]) unless country() in ['CZ', 'SK', 'PL', 'AT', 'SI']
        $.getJSON input.data('address-autocomplete'), { term: request.term, country: country() }, response
      select: (event, ui) ->
        input.val(ui.item.value)
        $(input.data('zip')).val(ui.item.zip).trigger('change')
        $(input.data('town')).val(ui.item.town).trigger('change')
        false
